import React from 'react'

import Layout from '../components/layout'
import EnterpriseAIPage from '../components/enterprise-ai/EnterpriseAIPage'
import { ENTERPRISE_AI_PT } from '../constants/enterpriseAIContent'

const EnterpriseAIPagePt = () => (
  <Layout
    lang="pt"
    title={ENTERPRISE_AI_PT.seo.title}
    meta={{
      description: ENTERPRISE_AI_PT.seo.description,
      'og:title': ENTERPRISE_AI_PT.seo.ogTitle,
      'og:description': ENTERPRISE_AI_PT.seo.ogDescription,
      'twitter:title': ENTERPRISE_AI_PT.seo.ogTitle,
      'twitter:description': ENTERPRISE_AI_PT.seo.ogDescription,
    }}
    heroBleedBackground
    rootProps={{ className: 'page enterprise-ai' }}
  >
    <EnterpriseAIPage lang="pt" />
  </Layout>
)

export default EnterpriseAIPagePt
